<p-inputSwitch
  *ngIf="visible"
  [(ngModel)]="value"
  [attr.checked]="value"
  [inputId]="id"
  [name]="name"
  [tabindex]="tabindex"
  [style]="style"
  [styleClass]="styleClass"
  [disabled]="disabled"
  [readonly]="readonly"
  [trueValue]="trueValue"
  [falseValue]="falseValue"
  (onChange)="mxChange($event)"
></p-inputSwitch>
